var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { MatDialog } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { AdoptionCourseSearchDialogComponent, BaseAdoptionCourseSearchDialogOptions, } from './adoptioncoursesearch/adoptioncoursesearch.dialogcomponent';
import { CheckboxDialogComponent, _CheckboxDialogOptions } from './checkbox/checkbox.dialogcomponent';
import { ClassicNotificationDialogComponent, BaseClassicNotificationDialogOptions, } from './classicnotification/classicnotification.dialogcomponent';
import { CountdownDialogComponent, _CountdownDialogOptions } from './countdown/countdown.dialogcomponent';
import { CourseChoiceDialogComponent, BaseCourseChoiceDialogOptions, BaseCourseChoiceResult, } from './coursechoice/coursechoice.dialogcomponent';
import { CourseDescriptionDialogComponent, _CourseDescriptionDialogOptions, } from './coursedescription/coursedescription.dialogcomponent';
import { CourseNoteDialogComponent, _CourseNoteDialogOptions } from './coursenote/coursenote.dialogcomponent';
import { ConfirmationDialogComponent, _ConfirmationDialogOptions } from './confirmation/confirmation.dialogcomponent';
import { EligibleCoursesDialogComponent } from './eligiblecourses/eligiblecourses.dialogcomponent';
import { FullScheduleDialogComponent, BaseFullScheduleDialogOptions } from './fullschedule/fullschedule.dialogcomponent';
import { InputBoxDialogComponent, _InputBoxDialogOptions } from './inputbox/inputbox.dialogcomponent';
import { MessageBoxDialogComponent, BaseMessageBoxDialogOptions } from './messagebox/messagebox.dialogcomponent';
import { NotificationDialogComponent, BaseNotificationDialogOptions } from './notification/notification.dialogcomponent';
import { ProxyApproveDialogComponent, BaseProxyApproveDialogOptions } from './proxyapprove/proxyapprove.dialogcomponent';
import { ReportOptionsDialogComponent, BaseReportOptionsDialogOptions, BaseReportRunOptions, } from './reportoptions/reportoptions.dialogcomponent';
import { ScheduleCourseDialogComponent, _ScheduleCourseDialogOptions } from './schedulecourse/schedulecourse.dialogcomponent';
import { StudentSearchDialogComponent, BaseStudentSearchDialogOptions } from './studentsearch/studentsearch.dialogcomponent';
import { OptionBoxDialogComponent, BaseOptionBoxDialogOptions, BaseOptionBoxOption } from './optionbox/optionbox.dialogcomponent';
import { TextNoteDialogComponent, _TextNoteDialogOptions } from './textnote/textnote.dialogcomponent';
import { UserSearchDialogComponent, BaseUserSearchDialogOptions, BaseUserSearchResultInfo, } from './usersearch/usersearch.dialogcomponent';
import { EditTestThresholdDialogComponent, _EditTestThresholdDialogOptions } from './edittestthreshold/edittestthreshold.dialogcomponent';
import { UpdateCollegeIDDialogComponent } from './updatecollegeID/updatecollegeID.dialogcomponent';
export { BaseAdoptionCourseSearchDialogOptions as AdoptionCourseSearchDialogOptions };
export { _CheckboxDialogOptions as CheckboxDialogOptions };
export { BaseClassicNotificationDialogOptions as ClassicNotificationDialogOptions };
export { _CountdownDialogOptions as CountdownDialogOptions };
export { _ConfirmationDialogOptions as ConfirmationDialogOptions };
export { BaseCourseChoiceDialogOptions as CourseChoiceDialogOptions };
export { BaseCourseChoiceResult as CourseChoiceResult };
export { _CourseDescriptionDialogOptions as CourseDescriptionDialogOptions };
export { _CourseNoteDialogOptions as CourseNoteDialogOptions };
export { _EditTestThresholdDialogOptions as EditTestThresholdDialogOptions };
export { BaseFullScheduleDialogOptions as FullScheduleDialogOptions };
export { _InputBoxDialogOptions as InputBoxDialogOptions };
export { BaseMessageBoxDialogOptions as MessageBoxDialogOptions };
export { BaseNotificationDialogOptions as NotificationDialogOptions };
export { BaseOptionBoxDialogOptions as OptionBoxDialogOptions };
export { BaseOptionBoxOption as OptionBoxOption };
export { BaseProxyApproveDialogOptions as ProxyApproveDialogOptions };
export { BaseReportOptionsDialogOptions as ReportOptionsDialogOptions };
export { BaseReportRunOptions as ReportRunOptions };
export { _ScheduleCourseDialogOptions as ScheduleCourseDialogOptions };
export { BaseStudentSearchDialogOptions as StudentSearchDialogOptions };
export { _TextNoteDialogOptions as TextNoteDialogOptions };
export { BaseUserSearchDialogOptions as UserSearchDialogOptions };
export { BaseUserSearchResultInfo as UserSearchResultInfo };
var DialogService = /** @class */ (function () {
    function DialogService(matDialog, mediaChange) {
        var _this = this;
        this.matDialog = matDialog;
        this.mediaChange = mediaChange;
        this.smallMediaSize = mediaChange.isActive('screen and (max-width: 959px)');
        // Observe for media changes
        this.mediaChange.subscribe(function (media) {
            // Set flags accordingly with what we know.
            _this.smallMediaSize = media.mqAlias === 'xs' || media.mqAlias === 'sm';
        });
    }
    // #region Close All Dialogs Service Call
    DialogService.prototype.CloseAllDialogs = function () {
        this.matDialog.closeAll();
    };
    // #endregion
    // #region Open Adoption Course Search Dialog Service Call
    DialogService.prototype.OpenAdoptionCourseSearchDialog = function (options) {
        var self = this;
        var openHandle = this.matDialog.open(AdoptionCourseSearchDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Select Course', MessageText: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            width: self.smallMediaSize ? '80vw' : '900px',
            height: self.smallMediaSize ? '80vh' : '700px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Checkbox Dialog Service Call
    DialogService.prototype.OpenCheckboxDialog = function (options) {
        var openHandle = this.matDialog.open(CheckboxDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Information Requested', MessageText: '', OKText: 'OK' }, options),
            width: options.width || '800px',
            height: options.height || '400px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Classic Notification Dialog Service Call
    DialogService.prototype.OpenClassicNotificationDialog = function (options) {
        var self = this;
        var openHandle = this.matDialog.open(ClassicNotificationDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Notification Details', MessageText: '', OKText: 'OK' }, options),
            width: self.smallMediaSize ? '80vw' : '85vw',
            height: self.smallMediaSize ? '80vh' : '500px',
            maxHeight: '85vh',
            maxWidth: '85vw'
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Confirmation Dialog Service Call
    DialogService.prototype.OpenConfirmationDialog = function (options) {
        var self = this;
        var dlgoptions = {
            disableClose: true,
            data: __assign({ TitleText: 'Confirmation Requested...', MessageText: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            panelClass: 'confdialog',
            maxHeight: '85vh',
        };
        if (self.smallMediaSize) {
            dlgoptions.width = '80vw';
            dlgoptions.height = '80vh';
            dlgoptions.panelClass = ['confdialog', 'smalldialogpanel'];
        }
        var openHandle = this.matDialog.open(ConfirmationDialogComponent, dlgoptions);
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Countdown Dialog Service Call
    DialogService.prototype.OpenCountdownDialog = function (options) {
        var openHandle = this.matDialog.open(CountdownDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Please Wait...', MessageText: '', OKText: 'OK', CancelText: 'Cancel', Time: 60 }, options),
            width: '500px',
            height: '18rem',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Course Choice Dialog Service Call
    DialogService.prototype.OpenCourseChoiceDialog = function (options) {
        var self = this;
        var openHandle = this.matDialog.open(CourseChoiceDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Select Course', MessageText: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            width: self.smallMediaSize ? '80vw' : '900px',
            height: self.smallMediaSize ? '80vh' : '700px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Course Description Dialog Service Call
    DialogService.prototype.OpenCourseDescriptionDialog = function (options) {
        var self = this;
        var openHandle = this.matDialog.open(CourseDescriptionDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Course Information', MessageText: '', OKText: 'OK' }, options),
            width: self.smallMediaSize ? '80vw' : '900px',
            height: self.smallMediaSize ? '80vh' : '400px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Course Note Dialog Service Call
    DialogService.prototype.OpenCourseNoteDialog = function (options) {
        var openHandle = this.matDialog.open(CourseNoteDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Optional Note', MessageText: '', OKText: 'OK' }, options),
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Eligible Courses Dialog Service Call
    DialogService.prototype.OpenEditTestThresholdDialog = function (options) {
        var openHandle = this.matDialog.open(EditTestThresholdDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Edit Test Score', MessageText: '', OKText: 'OK' }, options),
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Eligible Courses Dialog Service Call
    DialogService.prototype.OpenEligibleCoursesDialog = function (options) {
        var openHandle = this.matDialog.open(EligibleCoursesDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Select Eligibility Courses', MessageText: '', OKText: 'OK' }, options),
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Input Box Dialog Service Call
    DialogService.prototype.OpenInputBoxDialog = function (options) {
        var openHandle = this.matDialog.open(InputBoxDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Information Requested...', MessageText: '', InputHint: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Message Box Dialog Service Call
    DialogService.prototype.OpenMessageBoxDialog = function (options) {
        var self = this;
        var openHandle = self.matDialog.open(MessageBoxDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Information', MessageText: '', OKText: 'OK' }, options),
            width: self.smallMediaSize ? '80vw' : options.width || '600px',
            height: self.smallMediaSize ? '80vh' : options.height || '400px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Notification Dialog Service Call
    DialogService.prototype.OpenNotificationDialog = function (options) {
        var self = this;
        var openHandle = this.matDialog.open(NotificationDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Notification Details', MessageText: '', OKText: 'OK' }, options),
            width: self.smallMediaSize ? '80vw' : '900px',
            height: self.smallMediaSize ? '80vh' : '400px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Option Box Dialog Service Call
    DialogService.prototype.OpenOptionBoxDialog = function (options) {
        var openHandle = this.matDialog.open(OptionBoxDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Please select', MessageText: '', Options: [] }, options),
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Proxy Approve Dialog Service Call
    DialogService.prototype.OpenProxyApproveDialog = function (options) {
        var self = this;
        var openHandle = this.matDialog.open(ProxyApproveDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Information Requested', MessageText: '' }, options),
            width: self.smallMediaSize ? '80vw' : '700px',
            height: self.smallMediaSize ? '80vh' : '400px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Report Options Dialog Service Call
    DialogService.prototype.OpenReportOptionsDialog = function (options) {
        var self = this;
        var openHandle = this.matDialog.open(ReportOptionsDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Choose Report Options', MessageText: '' }, options),
            width: self.smallMediaSize ? '80vw' : options.width || '700px',
            height: self.smallMediaSize ? '80vh' : options.height || '200px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Schedule All Courses Dialog Service Call
    DialogService.prototype.OpenScheduleAllCoursesDialog = function (options) {
        var openHandle = this.matDialog.open(FullScheduleDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Schedule All Courses', MessageText: '' }, options),
            width: options.width || '900px',
            height: options.height || '500px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Schedule Course Dialog Service Call
    DialogService.prototype.OpenScheduleCourseDialog = function (options) {
        var self = this;
        var dlgOptions = {
            disableClose: true,
            data: __assign({ TitleText: 'Schedule Course', MessageText: '' }, options),
            width: options.width || '900px',
            height: options.height || '400px',
            maxHeight: '85vh',
        };
        if (self.smallMediaSize) {
            dlgOptions.width = '80vw';
            dlgOptions.height = '80vh';
        }
        var openHandle = this.matDialog.open(ScheduleCourseDialogComponent, dlgOptions);
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Student Search Dialog Service Call
    DialogService.prototype.OpenStudentSearchDialog = function (options) {
        var self = this;
        var openHandle = this.matDialog.open(StudentSearchDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'DELTA Student Search', MessageText: '' }, options),
            width: self.smallMediaSize ? '80vw' : '900px',
            height: self.smallMediaSize ? '80vh' : '750px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Text Note Dialog Service Call
    DialogService.prototype.OpenTextNoteDialog = function (options) {
        var openHandle = this.matDialog.open(TextNoteDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Optional Note', MessageText: '', OKText: 'OK' }, options),
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open Update College ID Dialog Service Call
    DialogService.prototype.OpenUpdateCollegeIDDialog = function (options) {
        var openHandle = this.matDialog.open(UpdateCollegeIDDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'Update College ID...', MessageText: '', InputHint: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    // #endregion
    // #region Open User Search Dialog Service Call
    DialogService.prototype.OpenUserSearchDialog = function (options) {
        var openHandle = this.matDialog.open(UserSearchDialogComponent, {
            disableClose: true,
            data: __assign({ TitleText: 'County Employee User Search', MessageText: '', OKText: 'OK', CancelText: 'Cancel' }, options),
            width: options.width || '1000px',
            height: options.height || '750px',
            maxHeight: '85vh',
        });
        return openHandle.afterClosed();
    };
    return DialogService;
}());
export { DialogService };
var BaseDialogOptions = /** @class */ (function () {
    function BaseDialogOptions() {
    }
    return BaseDialogOptions;
}());
export { BaseDialogOptions };



// WEBPACK FOOTER //
// ./src/services/dialogs/dialogs.service.ts.pre-build-optimizer.js